import type { FC } from "react";

import { WEBSITE_ANALYSIS_WIDGET_NAMES } from "app/pages/sales-intelligence/pages/company-analysis/constants";
import WWOSearchTrafficPaid from "app/pages/website-performance/components/SearchTraffic/paid/WWOSearchTrafficPaid";
import {
    getAdsCtaLinkForSI,
    getKeywordsCtaLinkForSI,
} from "app/pages/website-performance/components/SearchTraffic/utlis";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";

export const WWOSearchTrafficPaidContainerSI: FC = () => {
    return (
        <WWOSearchTrafficPaid
            getKeywordsCtaLink={getKeywordsCtaLinkForSI(WEBSITE_ANALYSIS_WIDGET_NAMES.paidSearchKeywords)}
            getAdsCtaLink={getAdsCtaLinkForSI}
            adsUnlockHook={{
                component: "WsWebSearchAds",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
            keywordsUnlockHook={{
                component: "WsWebSearchKeywords",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
            renderTextInsteadOfLinks
        />
    );
};
